(function () {

  "use strict";


  function initUAECheckout() {

    const checkout =
      document.getElementById("UAE-COD-Checkout");

    if (!checkout) return;


    const form =
      document.getElementById("uae-cod-form");

    const overlay =
      checkout.querySelector(".uae-cod-overlay");

    const closeButton =
      checkout.querySelector(".uae-cod-close");

    const submitButton =
      document.getElementById("uae-cod-submit");

    const submitText =
      checkout.querySelector(".uae-cod-submit-text");

    const spinner =
      checkout.querySelector(".uae-cod-spinner");

    const message =
      document.getElementById("uae-cod-message");


    const variantInput =
      document.getElementById("uae-cod-variant-id");

    const quantityInput =
      document.getElementById("uae-cod-quantity");

    const quantityDisplay =
      document.getElementById("uae-cod-qty-display");


    const subtotalElement =
      document.getElementById("uae-cod-subtotal");

    const discountElement =
      document.getElementById("uae-cod-discount");

    const discountRow =
      document.getElementById("uae-cod-discount-row");

    const codFeeRow =
      document.getElementById("uae-cod-fee-row");

    const codFeeElement =
      document.getElementById("uae-cod-cod-fee");

    const totalElement =
      document.getElementById("uae-cod-total");


    const productImage =
      document.getElementById("uae-cod-product-image");

    const productTitle =
      document.getElementById("uae-cod-product-title");

    const productVariant =
      document.getElementById("uae-cod-product-variant");

    const productPrice =
      document.getElementById("uae-cod-product-price");


    let currentVariant = null;

    let currentProduct = null;

    let currentQuantity = 1;

    let paymentMethod = "cod";


    /*
     * CONFIG
     */

    const COD_FEE = 15;

    const PREPAID_DISCOUNT = 0.10;


    /*
     * OPEN
     */

    function openCheckout() {

      clearMessage();

      updateVariantFromPage();

      updateQuantityFromPage();

      checkout.hidden = false;

      document.body.classList.add(
        "uae-cod-lock"
      );

      document.body.dispatchEvent(
        new CustomEvent(
          "uae-cod-open"
        )
      );

    }


    /*
     * CLOSE
     */

    function closeCheckout() {

      checkout.hidden = true;

      document.body.classList.remove(
        "uae-cod-lock"
      );

      clearMessage();

    }


    /*
     * GET SELECTED VARIANT
     */

    function getSelectedVariantId() {

      /*
       * Trade theme product form
       */

      const variantInputOnPage =
        document.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );


      if (
        variantInputOnPage &&
        variantInputOnPage.value
      ) {

        return String(
          variantInputOnPage.value
        );

      }


      /*
       * Any Shopify variant input
       */

      const fallback =
        document.querySelector(
          'input[name="id"][value]'
        );

      if (
        fallback &&
        fallback.value
      ) {

        return String(
          fallback.value
        );

      }


      return null;

    }


    /*
     * GET QUANTITY
     */

    function getSelectedQuantity() {

      const quantityInputOnPage =
        document.querySelector(
          'form[action*="/cart/add"] input[name="quantity"]'
        );

      if (
        quantityInputOnPage &&
        quantityInputOnPage.value
      ) {

        const quantity =
          parseInt(
            quantityInputOnPage.value,
            10
          );

        if (
          !isNaN(quantity) &&
          quantity > 0
        ) {

          return quantity;

        }

      }


      return 1;

    }


    /*
     * UPDATE VARIANT
     */

    async function updateVariantFromPage() {

      const variantId =
        getSelectedVariantId();

      if (!variantId) {

        showMessage(
          "Please select your size/color first."
        );

        return;

      }


      variantInput.value =
        variantId;


      try {

        const handle =
          checkout.dataset.productHandle;


        const response =
          await fetch(
            window.Shopify.routes.root +
            "products/" +
            handle +
            ".js"
          );


        if (!response.ok) return;


        const product =
          await response.json();


        currentProduct =
          product;


        const variant =
          product.variants.find(
            function (item) {

              return String(item.id) ===
                String(variantId);

            }
          );


        if (!variant) return;


        currentVariant =
          variant;


        updateProductDisplay();

        updateSummary();


      } catch (error) {

        console.error(
          "UAE Checkout variant error:",
          error
        );

      }

    }


    /*
     * PRODUCT DISPLAY
     */

    function updateProductDisplay() {

      if (!currentVariant) return;


      if (
        currentVariant.featured_image &&
        currentVariant.featured_image.src
      ) {

        productImage.src =
          currentVariant.featured_image.src;

      }


      if (currentProduct) {

        productTitle.textContent =
          currentProduct.title;

      }


      productVariant.textContent =
        currentVariant.title;


      productPrice.textContent =
        formatMoney(
          currentVariant.price
        );

    }


    /*
     * QUANTITY
     */

    function updateQuantityFromPage() {

      currentQuantity =
        getSelectedQuantity();


      if (
        currentQuantity < 1
      ) {

        currentQuantity = 1;

      }


      if (
        currentQuantity > 20
      ) {

        currentQuantity = 20;

      }


      quantityInput.value =
        currentQuantity;

      quantityDisplay.value =
        currentQuantity;


      updateSummary();

    }


    /*
     * FORMAT MONEY
     */

    function formatMoney(cents) {

      const amount =
        Number(cents) / 100;


      return (
        "AED " +
        amount.toFixed(2)
      );

    }


    /*
     * SUMMARY
     */

    function updateSummary() {

      if (!currentVariant) {

        return;

      }


      const subtotal =
        Number(currentVariant.price) *
        currentQuantity;


      let discount = 0;

      let codFee = 0;


      if (
        paymentMethod === "prepaid"
      ) {

        discount =
          Math.round(
            subtotal *
            PREPAID_DISCOUNT
          );

      } else {

        codFee =
          COD_FEE * 100;

      }


      const total =
        subtotal -
        discount +
        codFee;


      subtotalElement.textContent =
        formatMoney(subtotal);


      if (discount > 0) {

        discountRow.hidden =
          false;

        discountElement.textContent =
          "- " +
          formatMoney(discount);

      } else {

        discountRow.hidden =
          true;

      }


      if (
        paymentMethod === "cod"
      ) {

        codFeeRow.hidden =
          false;

        codFeeElement.textContent =
          formatMoney(codFee);

      } else {

        codFeeRow.hidden =
          true;

      }


      totalElement.textContent =
        formatMoney(total);

    }


    /*
     * PAYMENT METHOD
     */

    checkout
      .querySelectorAll(
        'input[name="payment_method"]'
      )
      .forEach(
        function (radio) {

          radio.addEventListener(
            "change",
            function () {

              paymentMethod =
                this.value;


              checkout
                .querySelectorAll(
                  ".uae-cod-payment-option"
                )
                .forEach(
                  function (option) {

                    option.classList.remove(
                      "active"
                    );

                  }
                );


              this
                .closest(
                  ".uae-cod-payment-option"
                )
                .classList.add(
                  "active"
                );


              updateSummary();

            }
          );

        }
      );


    /*
     * QUANTITY MINUS
     */

    document
      .getElementById("uae-cod-minus")
      .addEventListener(
        "click",
        function () {

          if (
            currentQuantity <= 1
          ) return;


          currentQuantity--;

          quantityInput.value =
            currentQuantity;

          quantityDisplay.value =
            currentQuantity;


          updateSummary();

        }
      );


    /*
     * QUANTITY PLUS
     */

    document
      .getElementById("uae-cod-plus")
      .addEventListener(
        "click",
        function () {

          if (
            currentQuantity >= 20
          ) return;


          currentQuantity++;

          quantityInput.value =
            currentQuantity;

          quantityDisplay.value =
            currentQuantity;


          updateSummary();

        }
      );


    /*
     * CLOSE EVENTS
     */

    closeButton.addEventListener(
      "click",
      closeCheckout
    );


    overlay.addEventListener(
      "click",
      closeCheckout
    );


    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key === "Escape" &&
          !checkout.hidden
        ) {

          closeCheckout();

        }

      }
    );


    /*
     * VALIDATION
     */

    function validateForm() {

      clearErrors();

      let valid = true;


      const name =
        document.getElementById(
          "uae-cod-name"
        );


      if (
        !name.value.trim()
      ) {

        setFieldError(
          name,
          "Please enter your name."
        );

        valid = false;

      }


      /*
       * UAE PHONE
       */

      const phone =
        document.getElementById(
          "uae-cod-phone"
        );


      const cleanPhone =
        phone.value
          .replace(/\D/g, "");


      if (
        !/^5\d{8}$/.test(
          cleanPhone
        )
      ) {

        setFieldError(
          phone,
          "Enter a valid UAE mobile number."
        );

        valid = false;

      }


      /*
       * EMIRATE
       */

      const emirate =
        document.getElementById(
          "uae-cod-emirate"
        );


      if (
        !emirate.value
      ) {

        setFieldError(
          emirate,
          "Please select your Emirate."
        );

        valid = false;

      }


      /*
       * AREA
       */

      const area =
        document.getElementById(
          "uae-cod-area"
        );


      if (
        !area.value.trim()
      ) {

        setFieldError(
          area,
          "Please enter your area/community."
        );

        valid = false;

      }


      /*
       * BUILDING
       */

      const building =
        document.getElementById(
          "uae-cod-building"
        );


      if (
        !building.value.trim()
      ) {

        setFieldError(
          building,
          "Please enter building/villa/flat."
        );

        valid = false;

      }


      /*
       * ADDRESS
       */

      const address =
        document.getElementById(
          "uae-cod-address"
        );


      if (
        !address.value.trim()
      ) {

        setFieldError(
          address,
          "Please enter complete address."
        );

        valid = false;

      }


      return valid;

    }


    function setFieldError(
      element,
      text
    ) {

      const field =
        element.closest(
          ".uae-cod-field"
        );


      if (!field) return;


      field.classList.add(
        "invalid"
      );


      const error =
        field.querySelector(
          ".uae-cod-error"
        );


      if (error) {

        error.textContent =
          text;

      }

    }


    function clearErrors() {

      checkout
        .querySelectorAll(
          ".uae-cod-field"
        )
        .forEach(
          function (field) {

            field.classList.remove(
              "invalid"
            );


            const error =
              field.querySelector(
                ".uae-cod-error"
              );


            if (error) {

              error.textContent =
                "";

            }

          }
        );

    }


    function clearMessage() {

      message.textContent =
        "";

    }


    function showMessage(text) {

      message.textContent =
        text;

    }


    /*
     * SUBMIT
     *
     * IMPORTANT:
     *
     * This version adds the selected
     * variant to Shopify Cart with
     * customer/address information
     * as cart attributes.
     *
     * Then it redirects to Shopify
     * checkout.
     */

    form.addEventListener(
      "submit",
      async function (event) {

        event.preventDefault();


        if (
          !validateForm()
        ) {

          return;

        }


        if (!currentVariant) {

          await updateVariantFromPage();

        }


        if (!currentVariant) {

          showMessage(
            "Please select a valid product variant."
          );

          return;

        }


        submitButton.disabled =
          true;

        submitText.textContent =
          "PROCESSING...";

        spinner.hidden =
          false;


        const name =
          document.getElementById(
            "uae-cod-name"
          ).value.trim();


        const phone =
          document.getElementById(
            "uae-cod-phone"
          ).value
            .replace(/\D/g, "");


        const email =
          document.getElementById(
            "uae-cod-email"
          ).value.trim();


        const emirate =
          document.getElementById(
            "uae-cod-emirate"
          ).value;


        const area =
          document.getElementById(
            "uae-cod-area"
          ).value.trim();


        const building =
          document.getElementById(
            "uae-cod-building"
          ).value.trim();


        const landmark =
          document.getElementById(
            "uae-cod-landmark"
          ).value.trim();


        const address =
          document.getElementById(
            "uae-cod-address"
          ).value.trim();


        try {

          /*
           * Add selected product
           * to Shopify cart.
           */

          const cartResponse =
            await fetch(
              window.Shopify.routes.root +
              "cart/add.js",
              {

                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",
                  "Accept":
                    "application/json"
                },

                body: JSON.stringify({

                  items: [

                    {

                      id:
                        Number(
                          currentVariant.id
                        ),

                      quantity:
                        currentQuantity

                    }

                  ]

                })

              }
            );


          if (
            !cartResponse.ok
          ) {

            const error =
              await cartResponse.json()
                .catch(
                  function () {
                    return {};
                  }
                );


            throw new Error(
              error.description ||
              error.message ||
              "Unable to add product to cart."
            );

          }


          /*
           * Save UAE customer data
           * as cart attributes.
           *
           * These attributes can be
           * carried to Shopify checkout.
           */

          const attributes = {

            "UAE Customer Name":
              name,

            "UAE Phone":
              "+971" + phone,

            "UAE Email":
              email,

            "UAE Emirate":
              emirate,

            "UAE Area":
              area,

            "UAE Building":
              building,

            "UAE Landmark":
              landmark,

            "UAE Delivery Address":
              address,

            "Payment Method":
              paymentMethod === "cod"
                ? "Cash on Delivery"
                : "Prepaid",

            "Checkout Type":
              "Custom UAE Checkout"

          };


          await fetch(
            window.Shopify.routes.root +
            "cart/update.js",
            {

              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },

              body:
                JSON.stringify({
                  attributes: attributes
                })

            }
          );


          /*
           * SUCCESS
           */

          submitText.textContent =
            "ORDER DETAILS SAVED";

          spinner.hidden =
            true;


          /*
           * COD:
           *
           * Send customer to checkout.
           *
           * Shopify checkout will use
           * the cart created above.
           */

          window.location.href =
            window.Shopify.routes.root +
            "checkout";


        } catch (error) {

          console.error(
            "UAE COD Checkout Error:",
            error
          );


          showMessage(
            error.message ||
            "Something went wrong. Please try again."
          );


          submitButton.disabled =
            false;

          submitText.textContent =
            "PLACE ORDER";

          spinner.hidden =
            true;

        }

      }
    );


    /*
     * INTERCEPT BUY NOW
     *
     * Trade theme uses product-form
     * and accelerated checkout button.
     */

    document.addEventListener(
      "click",
      function (event) {

        const target =
          event.target.closest(
            ".shopify-payment-button__button"
          );


        if (!target) return;


        /*
         * Don't interfere with disabled
         * buttons.
         */

        if (
          target.disabled ||
          target.getAttribute(
            "aria-disabled"
          ) === "true"
        ) {

          return;

        }


        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        openCheckout();


      },
      true
    );


    /*
     * Also support custom
     * data attribute buttons.
     *
     * If you add:
     *
     * data-uae-cod-buy-now
     *
     * to any button, it will open
     * this popup.
     */

    document.addEventListener(
      "click",
      function (event) {

        const target =
          event.target.closest(
            "[data-uae-cod-buy-now]"
          );


        if (!target) return;


        event.preventDefault();

        openCheckout();

      }
    );


    /*
     * When variant changes in
     * Trade theme, update popup.
     */

    document.addEventListener(
      "change",
      function (event) {

        if (
          event.target.matches(
            'input[name="id"], select[name="id"], select[name="options[Size]"], select[name="options[Color]"]'
          )
        ) {

          if (
            !checkout.hidden
          ) {

            updateVariantFromPage();

          }

        }

      }
    );


  }


  /*
   * INITIALIZE
   */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initUAECheckout
    );

  } else {

    initUAECheckout();

  }


})();